<div class="overlay">
  <div class="modal-content modal-w" (click)="$event.stopPropagation()">

    <div class="modal-header d-flex justify-content-between align-items-baseline">
      <h5 class="modal-title">Mensagem ocorrência</h5>
      <img class="bt-fechar me-3" src="assets/img/icons/close-white.svg" (click)="fecharModal()">
    </div>

    <div class="modal-body" style="background-color: #fff;">
      <div class="container-mensagem">
        <div class="header-mensagem">
            <span class="title" style="font-size: 14px; font-weight: 600;">Motorista / Ajudante</span>
            <span class="data" style="font-size: 12px;">{{ data | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="conteudo-mensagem">
            <div>{{mensagem}}</div>
            <div>
              <img style="cursor: pointer;" src="assets/img/icons/box-arrow-up-right.svg" alt="" (click)="onAbrirOcorrencia()">
            </div>
        </div>
      </div>
    </div>

  </div>
</div>